export default __webpack_public_path__ + "static/media/Masha Pappalardo.e17b1b6a.jpg";